import { ApplicationState } from './../index';

export const GetConfigData = (state: ApplicationState) => state.config;
